<template>
  <div id="transfer">
    <panel Title="فرم انتقال وجه" Des="از طریق این فرم می توانید بین حساب خود و اعضای وابسته درخواست انتقال وجه خود را ثبت نمایید." :IsBtnBack="true" ClassCustom="bg-dark-Custom text-right mt-2"></panel>
    <loading v-if="loadingRender"></loading>
    <net-pa-card>
      <template v-slot:header>
        <h6 class="text-right"><i class="fas fa-cloud-download-alt ml-2"></i>انتخاب حساب</h6>
      </template>
      <template slot="content">
        <div class="container">
          <div class="row">
            <div class="col-md-4 col-12">
              <div class="card Netpa-Shadow costom-card p-3 text-right">
                <div class="border-bottom border-warning pb-2 mb-2">
                  <b style="font-size: 15px !important" class="text-dark">انتخاب حساب مبداء</b>
                </div>
                <select v-if="IsLoad" @change="cheangcmbTaahodat()" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer" v-model="Resultcmb">
                  <option v-if="this.IsLoad == false" value="-2">|| در حال بارگذاری ، منتظر بمانید ... ||</option>
                  <option selected value="-1">-- انتخاب حساب --</option>
                  <option v-for="item in this.ListModel" :key="item.id" :value="item">
                    <span>{{ item.vcodeDesNo }} </span>
                    <span>{{ item.nameFamily }} </span>
                  </option>
                </select>
                <div v-if="Resultcmb != null && Resultcmb != '-1'" class="col-lg-12 col-md-12 col-12 text-center mt-2">
                  <p class="text-center m-0">موجودی</p>
                  <small class="card-text">{{ $Comma3ragham(Number(this.Resultcmb.mande) + Number(this.Resultcmb.sumMabTaeedNaShode)) }}</small>
                  <hr />
                  <p class="text-center m-0">قابل برداشت</p>
                  <small class="card-text">{{ $Comma3ragham(Number(this.Resultcmb.ghabelBardasht) + Number(this.Resultcmb.sumMabTaeedNaShode)) }}</small>
                  <hr />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="card Netpa-Shadow costom-card2 p-3 text-right">
                <div class="border-bottom border-warning pb-2 mb-2">
                  <b style="font-size: 15px !important" class="text-dark">انتخاب حساب مقصد</b>
                </div>
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <label class="btn btn-success active border-none" style="cursor: pointer; font-size: 13px"
                    ><input
                      @click="
                        ShowHesab(true)
                        SaveDetailHesab = false
                      "
                      type="radio"
                      name="options"
                      id="option1"
                      autocomplete="off"
                      checked
                    />حساب خود</label
                  >
                  <label class="btn btn-info border-none" style="cursor: pointer; font-size: 13px">
                    <input
                      @click="
                        ShowHesab(false)
                        SaveDetailHesab = false
                      "
                      type="radio"
                      name="options"
                      id="option2"
                      autocomplete="off"
                    />
                    حساب دیگران
                  </label>
                  <label class="btn btn-secondary border-none" style="cursor: pointer; font-size: 13px">
                    <input
                      @click="
                        SaveDetailHesab = true
                        IsHesab = null
                        GetDataShebaOrCard()
                      "
                      type="radio"
                      name="options"
                      id="option3"
                      autocomplete="off"
                    />
                    حساب های ذخیره شده
                  </label>
                </div>
                <select v-if="IsHesab == true" name="cmbTaahodat" id="cmbTaahodat" class="form-control Pointer mt-2" v-model="Resultcmb2">
                  <option v-if="this.IsLoad2 == false" value="-2">|| ... لطفا ابتدا حساب مبداء را انتخاب نمایید ... ||</option>
                  <option selected value="-1">-- انتخاب حساب --</option>
                  <option v-for="item in this.ListModel2" :key="item.id" :value="item">
                    <span>{{ item.vcodeDesNo }} </span>
                    <span>{{ item.nameFamily }} </span>
                  </option>
                </select>
                <div v-if="IsHesab == false" class="mt-2 row text-center">
                  <div class="col-9">
                    <input autocomplete="off" class="form-control text-center" dir="ltr" id="VCode" type="text" placeholder="شماره حساب | تسهیلات" v-model="VCode" v-mask="'###-##-#######'" />
                  </div>
                  <div class="col-3 pr-0">
                    <button type="button" @click="CheckupVcode()" class="btn btn-outline-orange rounded" style="font-size: 14px !important" dir="ltr">بررسی</button>
                  </div>
                  <div v-if="Result != null" class="col-lg-12 col-md-12 col-12 text-center mt-2">
                    <p class="text-center m-0">مشخصات</p>
                    <small class="card-text">{{ Result.nameFamily }}</small>
                    <hr />
                    <p class="text-center m-0">نوع حساب</p>
                    <small class="card-text">{{ Result.desNoe }}</small>
                    <hr />
                    <p v-if="tblSarfaslTypeId" class="text-center m-0">مبلغ قابل پرداخت</p>
                    <small v-if="tblSarfaslTypeId" class="card-text">{{ $Comma3ragham(sumGhabelPar) }}</small>
                    <hr />
                    <p v-if="tblSarfaslTypeId" class="text-center m-0">مبلغ جریمه</p>
                    <small v-if="tblSarfaslTypeId" class="card-text text-danger">{{ $Comma3ragham(wwwJarime) }}</small>
                  </div>
                  <div class="col-lg-12 col-md-12 col-12 text-center" v-if="Result != null">
                    <div class="custom-control custom-switch text-center">
                      <label class="mt-2 ml-2 Pointer"> ذخیره اطلاعات حســــاب </label>
                      <input type="checkbox" class="custom-control-input InputText" v-model="SaveHesab" id="SaveShebaOrCard" />
                      <label class="custom-control-label mt-2 Pointer" for="SaveShebaOrCard"></label>
                    </div>
                  </div>
                </div>

                <div class="mt-2 col-12 text-center" v-if="SaveDetailHesab && ListSaveHesab.length > 0">
                  <div class="BoxList row" :key="KEY">
                    <div class="col-12">
                      <div class="border-Sheba row mt-1 py-3 w-100" v-for="(item, key) in ListSaveHesab" :key="key">
                        <div class="col-md-12 text-center">
                          <div class="">
                            <span class="text-warning d-block"> حساب | تسهیلات </span>
                            <span>{{ item.shebaOrCardNum }}</span>
                          </div>
                          <div class="text-center">
                            <span class="text-warning d-block">نام صاحب حساب : </span>
                            <span>{{ item.sahebShebaOrCard }}</span>
                          </div>
                        </div>
                        <hr />
                        <div class="col-md-12 mt-2 text-center">
                          <span v-if="item.selected != true" class="Pointer mt-2 mr-3" style="font-size: 14px !important" @click="SelectSaveHesab(item.id)" title="انتخاب شماره"><i class="fa fa-check hover-info"></i></span>
                          <span v-else class="Pointer mt-2 mr-3" style="font-size: 14px !important"><i class="fa fa-check text-success"></i></span>
                          <span class="Pointer mt-2 mr-3" style="font-size: 14px !important" @click="RemoveShebeOrCard(item)" title="حذف شماره"><i class="fa fa-trash hover-danger"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="Resultcmb2 != null && Resultcmb2 != '-1'" class="col-lg-12 col-md-12 col-12 text-center mt-2">
                  <p class="text-center m-0">موجودی</p>
                  <small class="card-text">{{ $Comma3ragham(Number(this.Resultcmb2.mande) + Number(this.Resultcmb2.sumMabTaeedNaShode)) }}</small>
                  <hr />
                  <p class="text-center m-0">قابل برداشت</p>
                  <small class="card-text">{{ $Comma3ragham(Number(this.Resultcmb2.ghabelBardasht) + Number(this.Resultcmb2.sumMabTaeedNaShode)) }}</small>
                  <hr />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="card Netpa-Shadow costom-card3 p-3 text-right">
                <div class="border-bottom border-warning pb-2 mb-2">
                  <b style="font-size: 15px !important" class="text-dark">مبـــلغ انتقال</b>
                </div>
                <input ref="txtMablagh" id="txtMablagh" tabindex="1" class="form-control 3ragham text-center" style="font-size: 15px !important" v-model="txtMablagh" @keypress="$ValidNumber($event, 11)" />
                <textarea class="form-control text-right mt-3" type="text" placeholder="توضیحات" rows="4" v-model="Description"></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="!twoLevel" class="col-md-2 col-12"></div>
            <div v-if="!twoLevel" class="col-md-8 col-12">
              <button class="btn btn-block btn-warning" style="font-size: 14px !important" @click="checkSms()">
                {{ GetMablagh }}
              </button>
            </div>
            <div v-if="!twoLevel" class="col-md-2 col-12"></div>
            <div v-if="twoLevel == true" class="col-12">
              <div class="row mt-4">
                <hr class="mt-2" />
                <div class="col-md-2 col-12"></div>
                <div class="col-md-6 col-12">
                  <small>لطفا رمز پیامک شده را برای انجام تراکنش را وارد کنید</small>
                  <input v-model="twstepCode" type="number" class="form-control text-center" />
                </div>
                <div class="col-md-2 col-12">
                  <button @click="CheckCode" class="btn btn-success mt-4 w-100">تایید</button>
                </div>
                <div class="col-md-2 col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </net-pa-card>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import Panel from '../Tools/NetPa/Panel.vue'
import loading from '../Tools/NetPa/Loading.vue'

export default {
  components: {
    Panel,
    NetPaCard,
    loading,
  },
  data() {
    return {
      twstepCode: '',
      twoLevel: false,
      KEY: 0,
      ListSaveHesab: [],
      SaveDetailHesab: false,
      SaveHesab: false,
      DataAxios_Variz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'VarizGorohi/SetVarizGorohi',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat/TaahodatSahebHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxios_Enteghal: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'EnteghalVajh',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosRowVCode: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TaahodatByVC',
        Token: this.$session.get('TokenNetPa'),
      },
      Description: '',
      IsLoad: false,
      Resultcmb: null,
      loadingRender: false,
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad2: false,
      ListModel2: null,
      ListModelSahebHesab2: null,
      Resultcmb2: null,
      txtMablagh: 0,
      IsHesab: true,
      VCode: '',
      Result: null,
      wwwJarime: 0,
      sumGhabelPar: 0,
      tblSarfaslTypeId: false,
      MabFormulaJarime: 0,
      WwwtblAzaId: null,
      BnpCashDBtblTaahodatId: null,
      BnpCashDBtblAzaId: null,
    }
  },
  mounted() {
    this.GetData()
  },
  updated() {
    this.$PutCommatoInput()
  },
  methods: {
    GetData() {
      const formData = new FormData()
      let info
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formData.append('wwwtblSarfaslTypeId', 2)
      this.DataAxios_cmbTaahodat.ArryfildValue = formData
      this.$PostFormData(this.DataAxios_cmbTaahodat)
        .then((data) => {
          this.IsLoad = true
          this.ListModel = data.filter((x) => x.tblSarfaslTypeId != 6)
          this.Resultcmb = '-1'
        })
        .finally(() => {
          const formData = new FormData()
          formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
          formData.append('wwwtblSarfaslTypeId', 2)
          this.DataAxios_SahebHesab.ArryfildValue = formData
          this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
            if (data.length > 0) {
              this.IsLoad = true
              this.ListModelSahebHesab = data
              for (let index = 0; index < this.ListModelSahebHesab.length; index++) {
                if (this.ListModelSahebHesab[index].hasHaghEmza == true) {
                  info = this.ListModelSahebHesab[index]
                }
                this.ListModel.push(info)
              }
            }
          })
        })
    },
    ShowHesab(status) {
      this.IsHesab = status
      if (!status) {
        this.Result = null
      }
    },
    CheckupVcode() {
      if (this.VCode != '') {
        this.loadingRender = true
        this.Shenase = ''
        const formData = new FormData()
        formData.append('VCode', this.VCode)
        this.DataAxiosRowVCode.ArryfildValue = formData

        this.$PostFormData(this.DataAxiosRowVCode).then((data) => {
          if (data != null) {
            //Maghsad
            this.Result = data
            this.Resultcmb2 = null
            this.loadingRender = false
            if (data.tblSarfaslTypeId == 1) {
              // console.log('data*/*/*',data);
              this.tblSarfaslTypeId = true
              this.sumGhabelPar = data.sumGhabelPar

              this.wwwJarime = data.wwwJarime
              this.txtMablagh = this.$Comma3ragham(data.sumGhabelPar)

              this.WwwtblAzaId = data.wwwtblAzaId
              this.BnpCashDBtblTaahodatId = data.bnpCashDBtblTaahodatId
              this.BnpCashDBtblAzaId = data.bnpCashDBtblAzaId
            } else {
              this.tblSarfaslTypeId = false
              this.sumGhabelPar = 0
              this.wwwJarime = 0
              this.txtMablagh = 0
            }
          } else {
            this.$mySweetDefaultTost('خطا', 'شماره حساب وارد شده صحیح نمی باشد .', 'error', 2500)
            this.Result = null
            this.loadingRender = false
          }
        })
      } else {
        this.$mySweetDefault('خطا', 'شماره حساب نمی تواند خالی می باشد ', 'error', 2500)
        this.Result = null
      }
    },
    cheangcmbTaahodat() {
      if (this.Resultcmb != undefined || this.Resultcmb.id != '-1') {
        const formData = new FormData()
        let info
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxios_cmbTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_cmbTaahodat)
          .then((data) => {
            this.IsLoad2 = true
            this.ListModel2 = data.filter((x) => x.id != this.Resultcmb.id && x.tblSarfaslTypeId != 6)
          })
          .finally(() => {
            const formData = new FormData()
            formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
            formData.append('wwwtblSarfaslTypeId', 2)
            this.DataAxios_SahebHesab.ArryfildValue = formData
            this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
              if (data.length > 0) {
                this.IsLoad2 = true
                this.ListModelSahebHesab2 = data.filter((x) => x.id != this.Resultcmb.id)
                for (let index = 0; index < this.ListModelSahebHesab2.length; index++) {
                  info = this.ListModelSahebHesab2[index]
                  this.ListModel2.push(info)
                }
              }
            })
          })
      }
    },

    checkSms() {
      if (this.$session.get('CustCode') == '801' || this.$session.get('CustCode') == '255') {
        this.sendTwoStepCode()
      } else this.SabtEnteghal()
    },
    sendTwoStepCode() {
      this.twoLevel = true
      var DataAxiosSms = { Method: 'GET', Token: this.$session.get('TokenNetPa'), Action: 'twoStepVerification?wwwtblAzaId=' + this.$session.get('UserInfoNetPa').wwwtblAzaId, ArryfildValue: null }
      this.$PostData(DataAxiosSms).then((result) => {
        if (result.status == 'success') {
          this.$mySweetDefaultTost('', result.msg, 'success', 2800)
        }
      })
    },
    CheckCode() {
      var DataAxiosCheckCode = { Method: 'POST', Token: this.$session.get('TokenNetPa'), Action: 'twoStepVerification', ArryfildValue: { wwwtblAzaId: this.$session.get('UserInfoNetPa').wwwtblAzaId, Code: this.twstepCode + '' } }
      this.$PostData(DataAxiosCheckCode).then((result) => {
        if (result.status) {
          this.SabtEnteghal()
        } else {
          this.$mySweetDefaultTost('خطا', 'رمز دو مرحله ای وارد شده صحیح نمیباشد. دوباره تلاش کنید', 'error', 2800)
        }
      })
    },

    SabtEnteghal() {
      if (this.txtMablagh <= 0) {
        this.$mySweetDefaultTost('عدم ورود مبلغ صحیح', 'مبلغ انتقال وجه صفر یا وارد نشده است', 'warning', 3000)
      } else {
        if (this.Resultcmb == null || (this.Resultcmb2 == null && this.Result == null)) {
          this.$mySweetDefaultTost('عدم انتخاب حساب', 'حساب مبداء یا مقصد انتخاب نشده است', 'warning', 3000)
        } else {
          if (Number(this.txtMablagh.replaceAll(/,/g, '')) < Number(this.sumGhabelPar)) {
            var MablaghJarime = this.wwwJarime > 0 ? this.wwwJarime : 0
            this.MabFormulaJarime = (Number(this.txtMablagh.replaceAll(/,/g, '')) / (Number(this.sumGhabelPar) - MablaghJarime)) * MablaghJarime
            // console.log(this.MabFormulaJarime);
          } else {
            this.MabFormulaJarime = this.wwwJarime > 0 ? this.wwwJarime : 0
            // console.log(this.MabFormulaJarime);
          }
          let ghabelBardasht = Number(this.Resultcmb.ghabelBardasht) + Number(this.Resultcmb.sumMabTaeedNaShode)
          let MablaghEnteghal = Number(this.txtMablagh.replaceAll(',', ''))

          if (MablaghEnteghal <= ghabelBardasht) {
            //Checkup Mahdodiyat enteghal dar roz
            if (MablaghEnteghal < 10000) {
              this.$mySweetDefaultTost('مبلغ انتقال نا درست', ' مبلغ انتقال نمیتواند کمتر از 10,000' + this.$cookies.get('VahedPool') + 'باشد', 'warning', 3000)
            } else {
              this.ChekMojavez(this.Resultcmb.id, this.txtMablagh.replaceAll(',', ''))
            }
            //................................................................
          } else {
            this.$mySweetDefaultTost('عدم انتقال وجه', ' مبـلـغ وارد شده بیشـتر از مبلغ قابل برداشت  حسـاب ' + this.Resultcmb.desNoe + ' میباشد ', 'warning', 3000)
          }
        }
      }
    },
    ChekMojavez(wwwtblTaahodatId, Amount) {
      var DataAxios_Check = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'TanzimatNoe/ChekMojavez',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblTaahodatId', wwwtblTaahodatId)
      formData.append('Amount', Amount)
      formData.append('IsBardasht', false)
      DataAxios_Check.ArryfildValue = formData
      this.$PostFormData(DataAxios_Check).then((data) => {
        if (data.status == 'Ok') {
          if (data.data[0].isMojaz == 1) {
            // console.log(this.Resultcmb2);
            let result
            if (this.Resultcmb2 != null) {
              result = this.Resultcmb2
              // result['nameFamily']=this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily
              result['nameFamily'] = ' '
            } else {
              result = this.Result
            }
            this.$SweetQustion(
              'اطمینان از انتقال وجه',
              ' از انتقال وجه به مبلغ ' +
                this.$Comma3ragham(Number(Amount.replace(/,/g, ''))) +
                this.$cookies.get('VahedPool') +
                ' به شماره حساب | شماره تسهیلات ' +
                this.$b_InvertCode(result.vCode, '-') +
                ' _ ' +
                result.desNoe +
                '  به نام آقا | خانم ' +
                ' [ ' +
                result.nameFamily +
                ' ] ' +
                ' اطمینان دارید ؟ ',
              'question',
              'تایید و انتقال',
              'انصراف',
              null,
              this.Enteghal,
              this.Cancel
            )
          } else {
            this.$mySweetDefaultTost('محدودیت انتقال روزانه', '  سقف انتقال وجه شما در امروز به پایان رسیده و یا مبلغ وارد شده بیشتر از حد مجاز روزانه' + ' ( ' + this.$Comma3ragham(data.data[0].maxEnteghal) + ' ) ' + this.$cookies.get('VahedPool') + ' می باشد', 'error', 3500)
          }
        } else {
          this.$mySweetDefaultTost('خطایی رخ داده', 'در انتقال وجه خطایی رخ داده لفا کمی بعد دوباره تلاش فرمایید', 'error', 3500)
        }
      })
    },
    Enteghal() {
      if (this.SaveHesab == true) {
        this.SaveDataShebaOrCard().then((data) => {
          if (data == true) {
            this.$mySweetDefaultTost('عملیات موفق', 'ذخیره اطلاعات حساب | تسهیلات با موفقیت انجام گردید', 'success', 2000)
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', 'ذخیره اطلاعات حساب | تسهیلات با خطا روبه رو شد', 'danger', 2000)
          }
        })
      }
      //// کدهای ثبت واریز گروهی
      const WwwtblVarizGorohiRiz = []
      if (this.tblSarfaslTypeId == true) {
        /*wwwtblTaahodatIdBestanKar*/
        WwwtblVarizGorohiRiz.push({
          WwwtblTaahodatId: this.Result != null ? this.Result.id : this.Resultcmb2.id,
          Mablagh: Number(this.txtMablagh.replaceAll(/,/g, '')),
          SharhRiz: 'واریز به حساب / تسهیلات ',
          WwwtblAzaId: this.WwwtblAzaId,
          BnpCashDBtblTaahodatId: this.BnpCashDBtblTaahodatId,
          BnpCashDBtblAzaId: this.BnpCashDBtblAzaId,
          MablaghJarime: this.wwwJarime,
          TarixGhest: '',
          IsTaahodatRiz: false,
        })
        /*wwwtblTaahodatIdBestanKar*/

        this.DataAxios_Variz.ArryfildValue.Mablagh = Number(this.txtMablagh.replaceAll(/,/g, ''))
        this.DataAxios_Variz.ArryfildValue.CodeRahgiri = 0
        this.DataAxios_Variz.ArryfildValue.Tarix = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.Sharh = ' انتقال وجه '
        this.DataAxios_Variz.ArryfildValue.ZamanInsert = this.$store.state.JalaliDate
        this.DataAxios_Variz.ArryfildValue.CustCode = Number(this.$session.get('UserInfoNetPa').custCode)
        this.DataAxios_Variz.ArryfildValue.tblComboIdVaziatGrp312 = 5538
        this.DataAxios_Variz.ArryfildValue.wwwtblAzaId = this.$session.get('UserInfoNetPa').wwwtblAzaId
        this.DataAxios_Variz.ArryfildValue.StatusVariz = 2
        this.DataAxios_Variz.ArryfildValue.WwwtblVarizGorohiRiz = WwwtblVarizGorohiRiz
        this.$PostData(this.DataAxios_Variz).then((result) => {
          if (result.status === 'Success') {
            ////کدهای ثبت انتقال وجه
            const formData = new FormData()
            if (this.Result != null) {
              formData.append('wwwtblTaahodatIdBestanKar', this.Result.id)
            } else {
              formData.append('wwwtblTaahodatIdBestanKar', this.Resultcmb2.id)
            }
            formData.append('wwwtblTaahodatIdBedehKar', this.Resultcmb.id)
            formData.append('Mablagh', this.txtMablagh)
            formData.append('Desc', this.Description)
            formData.append('KodRahgiri', '')
            formData.append('CardNo', '')
            formData.append('ShebaNo', '')
            formData.append('NameSahebHesab', this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily)
            formData.append('EnteghalNoe', 2)
            formData.append('HesabNo', '')
            formData.append('OrderId', '-2')
            formData.append('MabKarmozdEnteghal', 0)
            formData.append('MabKarmozdBnp', 0)
            formData.append('BankName', '')
            formData.append('ComboIdGrp324', 0)
            formData.append('TarixSanad', this.$store.state.JalaliDate)
            formData.append('VarizGorohiId', result.idRepoMaster)
            formData.append('wwwJarime', this.MabFormulaJarime)
            this.DataAxios_Enteghal.ArryfildValue = formData
            this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
              if (data.id > 0 && data.success == 'SUCCESS') {
                this.$mySweetDefaultTost('انتقال موفق', 'انتقال وجه با موفقیت انجام شد کد رهگیری : ' + data.codeRahgiri, 'success', 6000)
                Object.assign(this.$data, this.$options.data.call(this))
                this.GetData()
              } else {
                this.$mySweetDefaultTost('مشکل در انتقال وجه', 'مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید', 'warning', 3000)
              }
            })

            ////کدهای ثبت انتقال وجه
          }
        })
      } else {
        ////کدهای ثبت انتقال وجه
        const formData = new FormData()
        if (this.Result != null) {
          formData.append('wwwtblTaahodatIdBestanKar', this.Result.id)
        } else {
          formData.append('wwwtblTaahodatIdBestanKar', this.Resultcmb2.id)
        }
        formData.append('wwwtblTaahodatIdBedehKar', this.Resultcmb.id)
        formData.append('Mablagh', this.txtMablagh)
        formData.append('Desc', this.Description)
        formData.append('KodRahgiri', '')
        formData.append('CardNo', '')
        formData.append('ShebaNo', '')
        formData.append('NameSahebHesab', this.$session.get('UserInfoNetPa').ozvName + ' ' + this.$session.get('UserInfoNetPa').ozvFamily)
        formData.append('EnteghalNoe', 2)
        formData.append('HesabNo', '')
        formData.append('OrderId', '-2')
        formData.append('MabKarmozdEnteghal', 0)
        formData.append('MabKarmozdBnp', 0)
        formData.append('BankName', '')
        formData.append('ComboIdGrp324', 0)
        formData.append('TarixSanad', this.$store.state.JalaliDate)
        formData.append('VarizGorohiId', 0)
        formData.append('wwwJarime', this.MabFormulaJarime)
        this.DataAxios_Enteghal.ArryfildValue = formData
        this.$PostFormData(this.DataAxios_Enteghal).then((data) => {
          if (data.id > 0 && data.success == 'SUCCESS') {
            this.$mySweetDefaultTost('انتقال موفق', 'انتقال وجه با موفقیت انجام شد کد رهگیری : ' + data.codeRahgiri, 'success', 6000)
            Object.assign(this.$data, this.$options.data.call(this))
            this.GetData()
          } else {
            this.$mySweetDefaultTost('مشکل در انتقال وجه', 'مشکلی در انتقال وجه پیش آمده لطفا مجددا تلاش کنید', 'warning', 3000)
          }
        })

        ////کدهای ثبت انتقال وجه
      }
    },
    SaveDataShebaOrCard() {
      return new Promise((success, reject) => {
        let Data = {
          Id: 0,
          wwwtblAzaId: this.$session.get('UserInfoNetPa').wwwtblAzaId,
          IsSheba: false,
          SahebShebaOrCard: this.Result.nameFamily + ' _ ' + this.Result.desNoe,
          ShebaOrCardNum: this.Result.vCode,
          IsBardasht: false,
        }
        var DataAxiosFindShebaOrCard = { ArryfildValue: Data, Method: 'Post', Action: 'ShebaOrCard', Token: this.$session.get('TokenNetPa') }
        this.$PostData(DataAxiosFindShebaOrCard).then((data) => {
          if (data.status == 'Success') {
            success(true)
          }
          // else if(data.status == 'Dup') {
          //   //اطلاعات شبا و یا کارت تکراری بوده
          // }
          else {
            //خطا در ذخیره
          }
        })
      })
    },
    Cancel() {},
    GetDataShebaOrCard() {
      var DataAxios = {
        ArryfildValue: '',
        Method: 'post',
        Action: 'ShebaOrCard/GetShebaOrCard',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        data.forEach((value) => {
          value['select'] = false
        })
        this.ListSaveHesab = data.filter((x) => x.isBardasht == false)
        this.KEY++
      })
    },
    SelectSaveHesab(id) {
      this.ListSaveHesab.forEach((el) => {
        if (el.id == id) {
          el.selected = true
          this.ShebaNo = el.shebaOrCardNum
          this.NameSahebHesab = el.sahebShebaOrCard
          this.VCode = el.shebaOrCardNum
          this.CheckupVcode()
          this.KEY++
        } else {
          el.selected = false
        }
      })

      this.SaveDetailHesab = false
      this.IsHesab = false
    },
    RemoveShebeOrCard(row) {
      this.$SweetQustion('اطمینان ازحذف', ' از حذف شماره حساب و یا تسهیلات ' + row.shebaOrCardNum + ' به نام  ' + row.sahebShebaOrCard + ' اطمینان دارید ؟ ', 'question', 'تایید حذف', 'انصراف', row.id, this.ConfirmRemoveShebaOrCard, this.isNotConfirmed)
    },
    ConfirmRemoveShebaOrCard(id) {
      var DataAxios = {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ShebaOrCard/DeleteShebaOrCard',
        Token: this.$session.get('TokenNetPa'),
      }
      const formData = new FormData()
      formData.append('wwwtbShebaOrCardId', id)
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((data) => {
        if (data.status == 'Success') {
          this.GetDataShebaOrCard()
          this.KEY++
          this.$mySweetDefaultTost('حذف موفق', ' حذف شماره شبا یا شماره کارت انتخابی شما با موفقیت انجام شد', 'success', 2000)
        }
      })
    },
    isNotConfirmed() {},
  },
  computed: {
    GetMablagh() {
      return ' انتقال  ' + this.$Comma3ragham(this.txtMablagh) + this.$cookies.get('VahedPool')
    },
  },
}
</script>
<style scoped>
.costom-card {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #f88282;

  margin-top: 50px;
  margin-bottom: 50px;
}

.costom-card2 {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px #9ffdaf;

  margin-top: 50px;
  margin-bottom: 50px;
}

.costom-card3 {
  padding: 20px 40px 20px 20px;
  border-radius: 15px;
  /* box-shadow: 0px 4px 8px 0px #435ebe; */

  margin-top: 50px;
  margin-bottom: 50px;
}
.BoxList {
  max-height: 30vh !important;
  overflow-y: scroll;
}

.border-Sheba {
  border: 2px dashed #435ebe !important;
  border-radius: 8px;
}
</style>
